import { useState } from "react";
import { faArrowDown, faArrowUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "react-bootstrap";
import { connect, useDispatch } from "react-redux";

import { Tabla } from "../../../components/Table/Table";

import { faEye } from "@fortawesome/free-regular-svg-icons";
import icon from "../../../assets/static/images/secciones/contribuyente.png";
import { v4 as uuidv4 } from "uuid";
import { getContribuyentes } from "../../../redux/Sections/MisContribuyentes/actions";
import EditContribuyente from "../../../components/ContribuyentesModal/EditContribuyente";
import CreateContribuyente from "../../../components/ContribuyentesModal/CreateContribuyente";
import DescargarExcel from "../../../components/DescargarExcel/DescargarExcel";
import { useUser } from "../../../hooks/useUser";
import { RowData } from "../Contribuyentes/Components/RowData/RowData";
import { MisContribuyentesFilter } from "./Components/MisContribuyentesFilter/MisContribuyentesFilter";

const MisContribuyentes = ({ dataList }) => {
  const dispatch = useDispatch();
  const user = useUser();
  const [showFilter, setShowFilter] = useState(true);
  const [show, setShow] = useState(false);
  const [showCreate, setShowCreate] = useState(false);
  const [showTable, setShowTable] = useState(false);
  const [contribuyente, setContribuyente] = useState();
  const [filters, setFilters] = useState({});

  const handleOpen = (row) => {
    setContribuyente(row);
    setShow(true);
  };
  const handleClose = () => setShow(false);

  const handleOpenCreate = () => setShowCreate(true);
  const handleCloseCreate = () => setShowCreate(false);

  const columns = [
    {
      title: "NOMBRE",
      dataIndex: "apynom",
      key: "apynom",
    },
    {
      title: "DNI",
      dataIndex: "dni",
      key: "dni",
    },
    {
      title: "DOMICILIO",
      dataIndex: "domicilio",
      key: "domicilio",
    },
    {
      title: "ACCIONES",
      dataIndex: "accion",
      render: (a, row) => <FontAwesomeIcon style={{ cursor: "pointer" }} title="Contribuyente" onClick={() => handleOpen(row)} icon={faEye} size="lg" />
    },
  ];


  const formatData = (dataTable) => {
    try {
      if (dataTable && dataTable?.length) {

        return dataTable.map((e) => {
          return {
            uuid: uuidv4(),
            ...e,
            domicilio: `${e.calle} ${e.nro}`
          };
        });
      } else {
        return [];
      }
    }
    catch (err) {
      console.log(err);
      return [];
    }
  };

  function exportData(list) {
    let filename = "mis-contribuyentes.xlsx";

    const dataList = list.map((e) => {
      return {
        "APELLIDO Y NOMBRE": e.APYNOM,
        "DNI": e.NRO_DOC,
        "DIRECCIÓN": `${e.CALLE} ${e.NRO}`,
      };
    });

    let name = "Contribuyentes";

    return {
      dataList,
      filename,
      name
    };
  }

  const reload = () => {
    return dispatch(getContribuyentes(filters));
  };
  
  return (
    <div className="section-container section-content">
      <div className="section-title d-flex align-items-center">
        <img src={icon} alt="contribuyente" />
        <span>Novedades</span>
      </div>
      {"A00" === user?.abogado ? ( 
        <div className="w-100 d-flex justify-content-end">
          <div>
            <Button
              onClick={handleOpenCreate}
              className="custom-button"
            >
            Agregar Contribuyente
            </Button>
          </div>
        </div>
      ) : null}

      <div className="buttons-filter">
        <h3 className="mr-3">Filtros:</h3>
        <div className="button-filter">
          {showFilter ?
            <Button
              variant="danger"
              onClick={() => setShowFilter(false)}
              className="danger-button d-flex align-items-center"
              style={{ maxWidth: 105 }}
            >
              <FontAwesomeIcon icon={faArrowDown} size="1x" /><span className="ml-2">Ocultar</span>
            </Button>
            : <Button
              onClick={() => setShowFilter(true)}
              className="custom-button d-flex align-items-center"
              style={{ maxWidth: 105 }}
            ><FontAwesomeIcon icon={faArrowUp} size="1x" /><span className="ml-2">Mostrar</span>
            </Button>}
        </div>
      </div>
      <div className="section-filter">
        <MisContribuyentesFilter
          showFilter={showFilter}
          setShowFilter={setShowFilter}
          style={{ marginBottom: "30px" }}
          action={getContribuyentes}
          setShowTable={setShowTable}
          section="mis-contribuyentes"
          setFilters={setFilters}
        />
      </div>
      {showTable ? (
        <div className="section-table">
          <Tabla
            dataList={formatData(dataList)}
            columns={columns}
            expandable={false}
            selection={false}
            RowData={RowData}
          />
          <div className="mt-3">
            <div style={{ maxWidth: 170 }}>
              <DescargarExcel data={exportData(dataList)} />
            </div>
          </div>
        </div>
      ) : null}
      {showCreate ? <CreateContribuyente show={showCreate} handleClose={handleCloseCreate} reload={reload} /> : null}
      {show ? <EditContribuyente show={show} handleClose={handleClose} contribuyente={contribuyente} reload={reload} /> : null}
    </div>
  );
};

const mapStateToProps = (state) => {
  return ({
    dataList: state.dashboard.contList
  });
};

const mapDispatchToProps = (dispatch) => {
  return {
    getData: (data) => dispatch(getContribuyentes(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MisContribuyentes);